import type { Prisma, users } from '@prisma/client';
import axiosInstance from '../api';

export interface UsersCreate {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone?: string;
  recaptchaToken?: string;
}

const usersService = {
  post: async (user: UsersCreate) => {
    const res = await axiosInstance.post<users>('/users', user);
    return res.data;
  },
  patch: async (user: Prisma.usersUpdateInput, userId: string) => {
    const res = await axiosInstance.patch<users>(`/users/${userId}`, user);
    return res.data;
  },
  remove: async (userId: string) => {
    const res = await axiosInstance.delete(`/users/${userId}`);
    return res.data;
  },
};

export default usersService;
